// Menu Configuration for Global Navigation Bar (Gnb)

// Menu Types (labelKey/titleKey are i18n keys under namespace 'menu')
export interface MenuItem {
    key: string;
    labelKey: string;
    to?: string;
    href?: string;
    hasSubmenu?: boolean;
}

export interface SubMenuItem {
    menuKey: string;
    titleKey: string;
    to: string;
    descriptionKey?: string;
}

export interface SubMenuCategory {
    [key: string]: SubMenuItem;
}

export interface SubMenuConfig {
    [key: string]: SubMenuCategory;
}

export interface MenuConfig {
    [role: string]: MenuItem[];
}

// Submenu Data Configuration
export const subMenuData: SubMenuConfig = {
    'customers': {
        'organizations': { menuKey: 'organizations', titleKey: 'organizations', to: '/admin/organizations' },
        'users': { menuKey: 'users', titleKey: 'users', to: '/admin/users' }
    },
    sales: {
        'orders': { menuKey: 'orders', titleKey: 'orders', to: '/admin/order-management' },
        'product-management': { menuKey: 'product-management', titleKey: 'productManagement', to: '/admin/product-management' },
        'class-management': { menuKey: 'class-management', titleKey: 'classManagement', to: '/admin/class-management' },
    },
    'assets': {
        'dialogues': { menuKey: 'dialogues', titleKey: 'dialogues', to: '/admin/assets/dialogues'},
        'tasks': { menuKey: 'tasks', titleKey: 'tasks', to: '/admin/assets/tasks'},
        'events': { menuKey: 'events', titleKey: 'events', to: '/admin/assets/events'},
        'symptoms': { menuKey: 'symptoms', titleKey: 'symptoms', to: '/admin/assets/symptoms'},
        'items': { menuKey: 'items', titleKey: 'items', to: '/admin/assets/items' },
    },
    'support': {
        'resources': { menuKey: 'resources', titleKey: 'resources', to: '/resources' },
        'contact': { menuKey: 'contact', titleKey: 'contactUs', to: '/contact' }
    }
};

// Role-based Menu Configuration
export const menuConfig: MenuConfig = {
    visitor: [
        { key: 'openClasses', labelKey: 'openClasses', to: '/open-class-list' },
        { key: 'blog', labelKey: 'blog', to: '/blog' },
        { key: 'resources', labelKey: 'resources', to: '/resources' },
        { key: 'contact', labelKey: 'contact', to: '/contact' }
    ],
    guest: [
        { key: 'openClasses', labelKey: 'openClasses', to: '/open-class-list' },
        { key: 'blog', labelKey: 'blog', to: '/blog' },
        { key: 'resources', labelKey: 'resources', to: '/resources' },
        { key: 'contact', labelKey: 'contact', to: '/contact' }
    ],
    student: [
        { key: 'openClasses', labelKey: 'openClasses', to: '/open-class-list' },
        { key: 'blog', labelKey: 'blog', to: '/blog' },
        { key: 'resources', labelKey: 'resources', to: '/resources' },
        { key: 'contact', labelKey: 'contact', to: '/contact' }
    ],
    master: [
        /** 로그인 마스터는 /master 하위로 오픈클래스 목록 (동일 컴포넌트, basePath만 master) */
        { key: 'openClasses', labelKey: 'openClasses', to: '/master/open-class-list' },
        { key: 'blog', labelKey: 'blog', to: '/blog' },
        { key: 'resources', labelKey: 'resources', to: '/resources' },
        { key: 'contact', labelKey: 'contact', to: '/contact' }
    ],
    admin: [
        { key: 'openClasses', labelKey: 'openClasses', to: '/open-class-list' },
        { key: 'blog', labelKey: 'blog', to: '/blog' },
        { key: 'resources', labelKey: 'resources', to: '/resources' },
        { key: 'contact', labelKey: 'contact', to: '/contact' }
    ]
};
